module.exports = __webpack_public_path__ + "img/new-rule-create.1069307a.png";